
import { Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import { FaEdit, FaTimes, FaSave } from 'react-icons/fa';
import { colors } from '../../../../utils/Colors';

const BillHeader = ({ refNo, saving, onCancel, onSubmit }) => {
  return (
    <Card className="border-0 shadow-sm mb-4" style={{ backgroundColor: colors.TABLE_HEADERS }}>
      <Card.Body className="p-4">
        <Row className="align-items-center">
          <Col md={6}>
            <div className="d-flex align-items-center">
              <div className="bg-white bg-opacity-25 p-3 rounded-circle me-3">
                <FaEdit size={24} className="text-white" />
              </div>
              <div>
                <h2 className="fw-bold mb-1 text-white">Edit Bill - REF-{refNo}</h2>
                <p className="text-white text-opacity-75 mb-0">
                  Update all bill details
                </p>
              </div>
            </div>
          </Col>
          
          <Col md={6} className="text-md-end">
            <div className="d-flex gap-2 justify-content-md-end">
              <Button variant="outline-light" onClick={onCancel} className="px-4">
                <FaTimes className="me-2" />
                Cancel
              </Button>
              <Button variant="light" onClick={onSubmit} disabled={saving} className="px-4">
                {saving ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                  </>
                ) : (
                  <>
                    <FaSave className="me-2" />
                    Save Changes
                  </>
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default BillHeader;